"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _servicesCore = require("@makerdao/services-core");

var _ = function _() {};

var NullEventService =
/*#__PURE__*/
function (_LocalService) {
  (0, _inherits2.default)(NullEventService, _LocalService);

  /**
   * @param {string} name
   */
  function NullEventService() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'event';
    (0, _classCallCheck2.default)(this, NullEventService);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(NullEventService).call(this, name));
  }

  (0, _createClass2.default)(NullEventService, [{
    key: "on",
    value: function on() {}
  }, {
    key: "emit",
    value: function emit() {}
  }, {
    key: "ping",
    value: function ping() {}
  }, {
    key: "removeListener",
    value: function removeListener() {}
  }, {
    key: "registerPollEvents",
    value: function registerPollEvents() {}
  }, {
    key: "buildEmitter",
    value: function buildEmitter() {
      return {
        emit: _,
        on: _,
        removeListener: _,
        registerPollEvents: _,
        ping: _,
        dispose: _
      };
    }
  }]);
  return NullEventService;
}(_servicesCore.LocalService);

exports.default = NullEventService;